import React, { useState, useEffect } from "react";
import { CDBBtn } from "cdbreact";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Swal from "sweetalert2";

export const ModalDispatch = ({
  action,
  setPressedButton,
  skus,
  selectedSkus,
  setSelectedSkus,
  nameProvider,
  dispatchedskus,
  initialLoad,
}) => {
  const [selectedSku, setSelectedSku] = useState("");
  const [availableSkus, setAvailableSkus] = useState(skus);

  useEffect(() => {
    // Filtrar los SKU que ya existen en dispatchedskus
    const existingSkus = skus?.filter((sku) =>
      dispatchedskus?.some(
        (dispatchedSku) => dispatchedSku.CodeSap === sku.CodeSap
      )
    );

    // Actualizar la cantidad del SKU existente en selectedSkus
    const updatedSelectedSkus = existingSkus.map((existingSku) => {
      const dispatchedSku = dispatchedskus.find(
        (dispatchedSku) => dispatchedSku.CodeSap === existingSku.CodeSap
      );
      return { ...existingSku, quantity: dispatchedSku.QuantityShipped };
    });

    // Agregar los SKU encontrados a selectedSkus
    setSelectedSkus(updatedSelectedSkus);

    // Eliminar los SKU encontrados de availableSkus
    setAvailableSkus(
      skus.filter(
        (sku) =>
          !existingSkus.some(
            (existingSku) => existingSku.CodeSap === sku.CodeSap
          )
      )
    );
  }, [dispatchedskus, skus, setSelectedSkus]);

  const handleSelectChange = (event, value) => {
    setSelectedSku(value ? value.CodeSap : "");
  };

  const addSkuToTable = () => {
    if (selectedSku) {
      const skuToAdd = availableSkus.find((sku) => sku.CodeSap === selectedSku);
      setSelectedSkus([...selectedSkus, { ...skuToAdd, quantity: 0 }]);
      setAvailableSkus(
        availableSkus.filter((sku) => sku.CodeSap !== selectedSku)
      );
      setSelectedSku("");
    }
  };

  const removeSkuFromTable = (index) => {
    const removedSku = selectedSkus[index];
    setAvailableSkus([...availableSkus, removedSku]);
    setSelectedSkus(selectedSkus.filter((_, idx) => idx !== index));
  };

  const handleQuantityChange = (index, quantity) => {
    setSelectedSkus((prevSkus) => {
      const updatedSkus = [...prevSkus];
      updatedSkus[index] = { ...updatedSkus[index], quantity };
      return updatedSkus;
    });
  };

  return (
    <div className="modal-wrapper">
      <div className="modal-header">
        <h3 style={{ margin: 0, padding: "10px", textAlign: "center" }}>
          Carga de Skus para la orden de despacho{" "}
          {nameProvider.split("/*-/")[0]} del proveedor{" "}
          {nameProvider.split("/*-/")[1]}
        </h3>
        <CloseIcon
          onClick={() => {
            if (!initialLoad) {
              setPressedButton("closeModal");
            } else {
              Swal.fire({
                icon: "warning",
                title: "Orden de despacho vacía",
                html: "La orden de despacho debe tener al menos un SKU asociado. Por favor, agregue al menos un SKU para completar la orden.",
                confirmButtonText: "Entendido",
                confirmButtonColor: "#146284",
              });
            }
          }}
          style={{
            cursor: "pointer",
            padding: "15px",
            fontSize: "50px",
            color: "#666",
          }}
        />
      </div>
      <div className="modal-body">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            marginBottom: "20px",
          }}
        >
          <FormControl fullWidth style={{ maxWidth: "100%", height: "auto" }}>
            <Autocomplete
              options={availableSkus}
              getOptionLabel={(option) =>
                `${option.CodeSap} - ${option.SkuDescription}`
              }
              value={
                availableSkus.find((sku) => sku.CodeSap === selectedSku) || null
              }
              onChange={handleSelectChange}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Seleccione un SKU"
                  variant="outlined"
                  size="small"
                  style={{ width: "100%", minHeight: "40px" }}
                  InputLabelProps={{
                    shrink: true,
                  }}
                />
              )}
            />
          </FormControl>
          <div style={{ marginLeft: "10px" }}>
            <CDBBtn
              type="button"
              color="primary"
              outline
              onClick={addSkuToTable}
              style={{
                borderRadius: "5px",
                padding: "5px",
                backgroundColor: "#146284",
                border: "1px solid #146284",
              }}
            >
              <AddIcon style={{ color: "white", fontSize: "25px" }} />
            </CDBBtn>
          </div>
        </div>
        <TableContainer component={Paper}>
          <Table>
            <TableHead style={{ background: "#146284" }}>
              <TableRow>
                <TableCell style={{ color: "#fff", fontWeight: "bold" }}>
                  Código SAP
                </TableCell>
                <TableCell style={{ color: "#fff", fontWeight: "bold" }}>
                  Descripción
                </TableCell>
                <TableCell style={{ color: "#fff", fontWeight: "bold" }}>
                  Unidad
                </TableCell>
                <TableCell style={{ color: "#fff", fontWeight: "bold" }}>
                  Inventario
                </TableCell>
                <TableCell style={{ color: "#fff", fontWeight: "bold" }}>
                  Acciones
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {selectedSkus.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={6} style={{ textAlign: "center" }}>
                    Sin datos
                  </TableCell>
                </TableRow>
              ) : (
                selectedSkus.map((sku, index) => (
                  <TableRow key={index}>
                    <TableCell>{sku.CodeSap.toUpperCase()}</TableCell>
                    <TableCell>{sku.SkuDescription.toUpperCase()}</TableCell>
                    <TableCell>{sku.unit_type.toUpperCase()}</TableCell>
                    <TableCell>
                      <TextField
                        type="number"
                        size="small"
                        value={sku.quantity || 0}
                        onChange={(e) =>
                          handleQuantityChange(index, e.target.value)
                        }
                        InputProps={{ inputProps: { min: 0, step: "any" } }}
                        style={{ width: "110px" }}
                      />
                    </TableCell>
                    <TableCell>
                      <CDBBtn
                        type="button"
                        color="danger"
                        outline
                        onClick={() => removeSkuFromTable(index)}
                        style={{
                          borderRadius: "5px",
                          padding: "5px",
                          backgroundColor: "#b30000",
                          border: "1px solid #b30000",
                        }}
                      >
                        <DeleteIcon
                          style={{ color: "white", fontSize: "20px" }}
                        />
                      </CDBBtn>
                    </TableCell>
                  </TableRow>
                ))
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
      <div
        className="modal-footer"
        style={{ display: "flex", justifyContent: "flex-end" }}
      >
        <CDBBtn
          type="button"
          color="success"
          outline
          onClick={() => setPressedButton("loadSkus")}
          style={{
            backgroundColor: "#4caf50",
            border: "1px solid #4caf50",
            color: "#fff",
          }}
        >
          Guardar
        </CDBBtn>
      </div>
    </div>
  );
};
